import api, { getAPIV3Pooling } from '@/api'
import normalizeZoneItem from '@/api/normalization/zone'

export async function saveZone(zoneItem = {}) {
  if (!zoneItem.name) {
    throw new Error('name is required')
  }
  if (zoneItem.type === 'R' && !zoneItem.radius) {
    throw new Error('radius is required')
  }
  return await api.zone.create(zoneItem)
}

export async function getZones(options = {}) {
  let items = await api.zone.getAllPooling({
    poolingItemsPerRequest: 500,
    freezeItems: true,
    ...options,
  })

  items = items
    //.map((o) => Object.freeze(normalizeZoneItem(o)))
    .sort((a, b) => {
      return a.name < b.name ? -1 : 1
    })

  //Log invalid
  /*
  let invalid = items.filter(
    (item) => (item.isPolygon && !item.polygon) || !item.lat || !item.lng
  )
  console.info('getZones::invalid-stats', {
    count: invalid.length,
    details: invalid,
  })*/

  //Filter out invalid zones (missing polygon?)
  items = items.filter(
    (item) => !item.isPolygon || (item.isPolygon && !!item.polygon)
  )

  return items
}

export async function getZoneCategories() {
  return await getAPIV3Pooling({
    uri: `${api.APIUrls.APIV3_ZONE_CATEGORIES}?page=1&itemsPerPage=500&order[label]=asc`,
    transform(item) {
      return (function normalizeZoneCategoryItem(item) {
        return {
          id: item.id,
          name: item.label,
          isPrivate: item.private,
          perimeter: item.perimeter,
          isDefault: item.default,
        }
      })(item)
    },
  })
}
